import {Routes} from '@angular/router';
import {AuthGuard} from './guards/authGuard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout/logout.page').then(m => m.LogoutPage)
  },
  {
    path: 'patients',
    loadComponent: () => import('./pages/patient-list/patient-list.page').then(m => m.PatientListPage),
    canActivate: [AuthGuard(true, false)]
  },
  {
    path: 'patient',
    loadComponent: () =>
      import('./pages/patient/patient.page').then((m) => m.PatientPage),
    canActivate: [AuthGuard(true, false)]
  },
  {
    path: 'patient/:id',
    loadComponent: () =>
      import('./pages/patient/patient.page').then((m) => m.PatientPage),
    canActivate: [AuthGuard(true, false)]
  },

  {
    path: 'medicalscore/:patientMedicalScoreId',
    loadComponent: () => import('./pages/medicalscore/medicalscore.page').then(m => m.MedicalscorePage),
    canActivate: [AuthGuard(true, true)]
  },
  {
    path: 'medicalscore/:patientMedicalScoreId/section/:sectionId',
    loadComponent: () => import('./pages/medicalscoresection/medicalscoresection.page').then(m => m.MedicalscoresectionPage),
    canActivate: [AuthGuard(true, true)]
  },
  {
    path: 'code',
    loadComponent: () => import('./pages/code/code.page').then( m => m.CodePage),
  },
  {
    path: 'code/:code',
    loadComponent: () => import('./pages/code/code.page').then( m => m.CodePage),
  },
  {
    path: 'complete',
    loadComponent: () => import('./complete/complete.page').then( m => m.CompletePage)
  },
  {
    path: 'patient-add',
    loadComponent: () => import('./pages/patient-add/patient-add.page').then( m => m.PatientAddPage)
  },
  {
    path: 'patient/:patientId/procedure/:procedureId',
    loadComponent: () => import('./pages/procedure-edit/procedure-edit.page').then(m => m.ProcedureEditPage)
  },
  {
    path: 'patient/:patientId/procedure',
    loadComponent: () => import('./pages/procedure-edit/procedure-edit.page').then(m => m.ProcedureEditPage)
  },
  {
    path: '',
    redirectTo: 'patients',
    pathMatch: 'full',
  },
];
